import React from 'react';

/**
 * Label to display form input API messages.
 * types: ['error', 'success']
 */
const InputFeedback = ({ type = 'error', message }) => {
  const typeClasses = {
    error: 'u-color-mahogany',
    success: 'u-color-medium-aquamarine',
  };
  return (
    <div className={`${typeClasses[type]} u-font-size--small`}>
      {message || <>&nbsp;</>}
    </div>
  );
};

export default InputFeedback;
